import { extendTheme } from "@chakra-ui/react";
import { colors, semanticColors } from "./colors";
import { Alert } from "./components/alert";
import { Badge } from "./components/badge";
import { Button } from "./components/button";
import { Card } from "./components/card";
import { Checkbox } from "./components/checkbox";
import { FormLabel } from "./components/formLabel";
import { Input } from "./components/input";
import { Menu } from "./components/menu";
import { MultiSelect } from "./components/multiselect";
import { Progress } from "./components/progress";
import { Radio } from "./components/radio";
import { Select } from "./components/select";
import { Slider } from "./components/slider";
import { Table } from "./components/table";
import { Tabs } from "./components/tabs";
import { Text } from "./components/text";

const theme = extendTheme({
  breakpoints: {
    base: "0em", // 0px
    sm: "48em", // ~768px
    md: "64em", // ~1024px
    lg: "80em", // ~1280px
    xl: "96em", // ~1536px
  },

  colors,

  semanticTokens: {
    colors: semanticColors,
  },

  fonts: {
    heading: `'Lora', serif;`,
    body: `'Manrope', sans-serif;`,
  },

  components: {
    Alert,
    Badge,
    Button,
    Card,
    Checkbox,
    FormLabel,
    Input,
    Menu,
    MultiSelect,
    Progress,
    Radio,
    Select,
    Slider,
    Table,
    Tabs,
    Text,
    Form: {
      baseStyle: {
        helperText: {
          color: "gray.800",
        },
      },
    },
  },

  styles: {
    global: {
      "html, body": {
        color: "text",
        backgroundColor: "background.base",
        lineHeight: "tall",
      },
      ".chakra-form__helper-text": {
        color: "gray.800",
      },
      ".chakra-modal__content": {
        _dark: {
          bg: "black.700",
        },
      },
      a: {
        color: "teal.500",
      },
      "*:focus-visible": {
        outline: "3px solid",
        outlineColor: "yellow.500",
        outlineOffset: "3px",
        boxShadow: "none",
      },
      "@media (prefers-reduced-motion: reduce)": {
        "*, *::before, *::after": {
          animationDuration: "0.01ms !important",
          animationIterationCount: "1 !important",
          scrollBehavior: "auto !important",
          transitionDuration: "0.01ms !important",
        },
      },
    },
  },
});

export default theme;
